import LifecycleActivationController from "./lifecycle_activation_controller"

export default class extends LifecycleActivationController {
  static component = "office-revalidation"
}
